import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {pullRequestsAppBuilder} from './config/app-builder'
import {createPullRequestsRoutes} from './routes/create-pull-requests-routes'

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes(params =>
  createPullRequestsRoutes(pullRequestsAppBuilder, params),
)

registerDataRouterApp(pullRequestsApp)
